<!--Создаёт два контейнера для вмещения в себя списка МО по их типу-->

<template>
  <v-container grid-list-md text-xs-center style="max-width: fit-content">
    <v-layout v-if="isLoading === false" row wrap>
      <!-- Для 2024 и ранее: два списка -->
      <template v-if="year <= 2024">
        <v-flex lg7 md12 sm12 xs12>
          <regions-once-type :regions="districtsList">
            Муниципальные районы
          </regions-once-type>
        </v-flex>
        <v-flex lg5 md12 sm12 xs12>
          <regions-once-type :regions="citiesList">
            Городские округа
          </regions-once-type>
        </v-flex>
      </template>

      <!-- Для 2025 и позже: три списка -->
      <template v-else>
        <v-flex lg12 md12 sm12 xs12>
          <regions-once-type :regions="municipalAreasList">
            Муниципальные округа
          </regions-once-type>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12>
        <v-layout row wrap justify-center>
        <v-flex lg4 md6 sm12 xs12>
          <regions-once-type :regions="regionalCitiesList">
            Городские округа (Краевые города)
          </regions-once-type>
        </v-flex>
        <v-flex lg4 md6 sm12 xs12>
          <regions-once-type :regions="closedSettlementsList">
            Городские округа (ЗАТО)
          </regions-once-type>
        </v-flex>
        </v-layout>
        </v-flex>
      </template>
    </v-layout>
    <v-layout v-else>
      <vue-simple-spinner style="margin-top: 300px;" line-fg-color="#3f51b5" size="big" />
    </v-layout>
  </v-container>
</template>

<script>
import RegionsSelectedOnceType from "@/components/regions-selected-once-type";
import axios from "axios";
import Spinner from "vue-simple-spinner/src/components/Spinner";

export default {
  props: {
    year: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      districtsList: [],
      citiesList: [],
      municipalAreasList: [],
      regionalCitiesList: [],
      closedSettlementsList: [],
      isLoading: true,
    };
  },
  components: {
    "vue-simple-spinner": Spinner,
    "regions-once-type": RegionsSelectedOnceType
  },
  watch: {
    year: {
      handler(newYear) {
        this.loadMunicipality(newYear);
      },
      immediate: true
    }
  },
  methods: {
    loadMunicipality(year) {
      this.isLoading = true;
      axios
        .post("/eco-passport/get-municipality", { year })
        .then(response => {
          const data = response.data;

          this.districtsList = [];
          this.citiesList = [];
          this.municipalAreasList = [];
          this.regionalCitiesList = [];
          this.closedSettlementsList = [];

        if (year <= 2024) {
          this.districtsList = data.districts || [];
          this.citiesList = data.cities || [];
        } else {
          this.municipalAreasList = data.municipalAreas || [];
          this.regionalCitiesList = data.regionalCities || [];
          this.closedSettlementsList = data.closedSettlements || [];
        }

          this.isLoading = false;
        })
        .catch(e => {
          alert(e.toString());
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>